import { ForecastVersionResponse } from '@api-response-types/forecast-version.response';
import { createReducer, on } from '@ngrx/store';
import { ForecastVersionActions } from './forecast-version.actions';
import { ForecastVersionState } from './forecast-version.state';

export const initialState: ForecastVersionState = {
  allForecastVersions: [],
  isFetchingForecastVersions: false,
  deleteForecastVersionIsPending: false,
  createVersionIsPending: false,
};

export const forecastVersionReducer = createReducer(
  initialState,
  on(
    ForecastVersionActions.resetForecastVersion,
    (): ForecastVersionState => initialState,
  ),
  on(
    ForecastVersionActions.setGetAllForecastVersionsIsFetching,
    (state, { isFetching }): ForecastVersionState => ({
      ...state,
      isFetchingForecastVersions: isFetching,
    }),
  ),
  on(
    ForecastVersionActions.setAllForecastVersions,
    (state, { forecastVersions }): ForecastVersionState => ({
      ...state,
      allForecastVersions: forecastVersions,
    }),
  ),
  on(
    ForecastVersionActions.addForecastVersion,
    (state, { forecastVersion }) => ({
      ...state,
      allForecastVersions: [
        // Make sure no version is added twice
        ...state.allForecastVersions.filter((v) => v.id !== forecastVersion.id),
        forecastVersion,
      ],
    }),
  ),
  on(
    ForecastVersionActions.setDeleteForecastVersionIsPending,
    (state, { isPending }): ForecastVersionState => ({
      ...state,
      deleteForecastVersionIsPending: isPending,
    }),
  ),
  on(
    ForecastVersionActions.setCreateVersionIsPending,
    (state, { isPending }): ForecastVersionState => ({
      ...state,
      createVersionIsPending: isPending,
    }),
  ),
  on(
    ForecastVersionActions.setForecastVersion,
    (state, { forecastVersion }): ForecastVersionState => {
      const existingIndex = state.allForecastVersions.findIndex(
        (v) => v.id === forecastVersion.id,
      );
      if (existingIndex === -1) {
        return state;
      }

      const existing = state.allForecastVersions[existingIndex];
      const hasVersionProgressed =
        existing.status !== forecastVersion.status ||
        existing.progress !== forecastVersion.progress ||
        existing.estimatedDuration !== forecastVersion.estimatedDuration;
      if (!hasVersionProgressed) {
        // preserve state reference so downstream selectors/signals do not re-emit
        return state;
      }

      const updatedVersions: ForecastVersionResponse[] = [
        ...state.allForecastVersions,
      ];
      updatedVersions[existingIndex] = forecastVersion;

      return { ...state, allForecastVersions: updatedVersions };
    },
  ),
);
